import { HelperLut } from './../../volume-rendering/helpers/helpers.lut';
import { mapTo } from 'rxjs/operators';
import { EntityModel } from './../../model';
import {
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
} from '@angular/core';
import { Scene, Object3D, Group } from 'three';
import { Subject } from 'rxjs';
import { SceneService } from '../scene.service';
import { RendererService } from '../renderer.service';

export interface ThreeCanvas {
  scene: Scene;
  render$: Subject<void>;
}

export abstract class EntityComponent<T extends EntityModel>
  implements OnInit, OnDestroy, AfterViewInit {
  public entity: Object3D | undefined | Group;
  private changeSubject = new Subject<void>();
  protected ef;
  protected lut: HelperLut;
  readonly changed$ = this.changeSubject.pipe(mapTo(this.entity));
  // protected entity = this.entityService.entity;
  private _model = this.defaultModel();
  @Output()
  changed = new EventEmitter<T>();

  @Input()
  get model(): T {
    return this._model;
  }
  set model(m: T) {
    if (m === undefined) {
      return;
    }
    // if (this.entityService.entity === undefined) {
    //   this.entity2 = this.createEntity(this.model);
    //   this.entityService.create(this.createEntity(this.model));
    //   this.entityService.update((e) => this.updateEntity(m, e));
    // } else {
    //   this.entityService.update((e) => this.updateEntity(m, e));
    // }

    if (this.entity === undefined) {
      this.entity = this.createEntity(this.model);
      this.sceneService.add(this.entity);
      // console.log(this.sceneService.scene);
      this.rendererService.render();
      if (this.entity === undefined) {
        throw Error('Can not update undefined entity');
      }
      this.updateEntity(m,this.entity);
      this.rendererService.render();
    } else {
      if (this.entity === undefined) {
        throw Error('Can not update undefined entity');
      }
      this.updateEntity(m, this.entity);
      this.rendererService.render();
    }
    this.changed.emit(this.model);
  }

  constructor(
    public sceneService: SceneService,
    private rendererService: RendererService
  ) {}
  abstract createEntity(model: T): Object3D;
  abstract updateEntity(model: T, entity: Object3D): Object3D;
  abstract defaultModel(): T;

  get mesh() {
    return this.entity;
  }
  ngOnDestroy() {
    if (this.entity !== undefined) {
      this.sceneService.remove(this.entity);
      this.rendererService.render();
    }
    this.changeSubject.complete();
  }
  canvasReady() {}
  ngOnInit() {}
  ngAfterViewInit() {}
}
